import { frontendOptions } from './systemData'

const NEG_STATUS_FALLBACK = {
    escalated: { label: 'Escalated', value: 'escalated', color: 'Orange' },
    counteroffer: { label: 'Counteroffer', value: 'counteroffer', color: 'Red' },
    accepted: { label: 'Accepted', value: 'accepted', color: 'Green' },
}

/**
 * Derive negotiation status (mirrors backend CaseNegotiation::resolveNegStatus).
 */
export function resolveNegStatus(caseNegotiation, practices) {
    if (!caseNegotiation) {
        return null
    }

    // Active escalation takes precedence over a prior acceptance stamp.
    if (Number(caseNegotiation.escalate_negotiation) === 1) {
        const practiceList = practices ?? []
        const hasNegAmount = practiceList.some(
            (p) => p?.lia_neg_amount != null || p?.um_neg_amount != null
        )

        return hasNegAmount ? 'counteroffer' : 'escalated'
    }

    if (caseNegotiation.total_accepted_at) {
        return 'accepted'
    }

    return null
}

export function getNegStatusOption(status) {
    if (!status) {
        return null
    }
    return (
        (frontendOptions()?.NEG_STATUS ?? []).find((opt) => opt.value === status) ??
        NEG_STATUS_FALLBACK[status] ??
        null
    )
}

export function getNegStatusLabel(status) {
    return getNegStatusOption(status)?.label ?? null
}

/**
 * Apply optimistic case_negotiation field updates and refresh derived neg_status.
 */
export function optimisticUpdateCaseNegotiation(dispatch, caseActions, fields) {
    dispatch(
        caseActions.modifyActiveCaseMultipleObject({
            folder: 'case_negotiation',
            item: { fields },
        })
    )
}
